/* eslint-disable @typescript-eslint/no-shadow */

import { StyleSheetManager } from 'styled-components';
import type { JavascriptRequestDataModel } from 'autogen/swagger/all';
import { JavascriptRequestDataModelQueryKey } from 'autogen/swagger/all/hooks';
import { RecoilRoot } from 'recoil';
import QueryClientInitializer from 'setup/react-query/QueryClientInitializer';
import queryClient from 'setup/react-query/queryClient';
import { shouldForwardProp } from 'setup/styled-components/shouldForwardProp';
import ThemeProvider from 'theming/ThemeProvider';

function getJavascriptRequestDataModel() {
    return queryClient.getQueryData([JavascriptRequestDataModelQueryKey]);
}

// serverside
export const WrapProviders =
    // biome-ignore lint/style/useDefaultParameterLast: <explanation>
        (Component, stateData = getJavascriptRequestDataModel(), Router, queryClient, dehydratedState) =>
        (props) => (
            <Router basename="/">
                <QueryClientInitializer
                    queryClient={queryClient}
                    dehydratedState={dehydratedState}
                    data={{ javascriptRequestDataModel: stateData as JavascriptRequestDataModel }}
                >
                    <RecoilRoot>
                        <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                            <ThemeProvider theme="default">
                                <Component {...props} />
                            </ThemeProvider>
                        </StyleSheetManager>
                    </RecoilRoot>
                </QueryClientInitializer>
            </Router>
        );

// clientside
export const WrapAllComponents = (compObj, stateData, Router, queryClient, dehydratedState) => {
    const wrappedObj = {};

    function wrapperRecoil(key) {
        wrappedObj[key] = WrapProviders(compObj[key], stateData, Router, queryClient, dehydratedState);
    }

    Object.keys(compObj).map(wrapperRecoil);

    return wrappedObj;
};
